import * as React from 'react';
import b_ from 'b_';
import { Trans, useTranslation } from 'react-i18next';

import './index.scss';

interface Props {
  footer: React.ReactNode;
  children: React.ReactNode;
}

const b = b_.with('position-details-modal-content');

export const Content: React.FC<Props> = ({ children, footer }) => {
  const { t } = useTranslation();
  return (
    <>
      <section className={b()}>
        <h2 className={b('title')}>{t('Investment details')}</h2>
        <table className={b('table')}>
          <thead>
            <tr>
              <th>{t('Position operation')}</th>
              <th>
                <Trans i18nKey="Position stocks quantity">
                  Position stocks <br /> quantity
                </Trans>
              </th>
              <th>
                <Trans i18nKey="Position unit price">
                  Position unit <br /> price
                </Trans>
              </th>
              <th>
                <Trans i18nKey="Position transaction amount">
                  Position transaction <br /> amount
                </Trans>
              </th>
              <th>{t('Position commissions')}</th>
              <th>
                <Trans i18nKey="Account changes">
                  Account <br /> changes
                </Trans>
              </th>
              <th>{t('Date')}</th>
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
      </section>
      {footer}
    </>
  );
};
